import React from 'react';
import { Grid } from '@material-ui/core';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import {
  Description,
  OptionName,
  Special,
  TabIcon,
} from './BillingCycleOptionItem.style-elements';

export interface BillingCycleOptionItemDataProps {
  id: number;
  name: string;
  nameSpecial?: string;
  description: string;
}

interface BillingCycleOptionItemProps extends BillingCycleOptionItemDataProps {
  isActive?: boolean;
  isHover?: boolean;
  showTabIcon?: boolean;
}

const BillingCycleOptionItem: React.FC<BillingCycleOptionItemProps> = ({
  isActive,
  isHover,
  name,
  nameSpecial,
  description,
  showTabIcon = true,
}) => {
  return (
    <FsPaper withContentMargin={false}>
      <Grid container wrap="nowrap" spacing={2}>
        {showTabIcon && (
          <Grid item>
            <TabIcon isActive={isActive} isHover={isHover} />
          </Grid>
        )}

        <Grid item xs>
          <OptionName isActive={isActive}>
            {name}{' '}
            {nameSpecial && (
              <Special isActive={isActive}>{nameSpecial}</Special>
            )}
          </OptionName>
          <Description>{description}</Description>
        </Grid>
      </Grid>
    </FsPaper>
  );
};

export default BillingCycleOptionItem;
